import React from 'react';
import { createBrowserRouter } from 'react-router';

import { mountReactRoot } from 'utils/reactRoot';

import App from './App';

const rootEl = document.getElementById('root');
if (rootEl) {
  const router = createBrowserRouter([{ path: '*', element: null }]);
  mountReactRoot(
    <React.StrictMode>
      <App router={router} />
    </React.StrictMode>,
    rootEl,
  );
}
